import { ElementDescription } from './ElementDescription';
import type { ElementDescriptionSetJSON } from './ElementDescriptionSet';
import { ElementDescriptionSet } from './ElementDescriptionSet';
import { MapRepository } from '@framework/repository';
import type { ElementDescriptionJSON, ModelId, ViewModelId, DBPath } from 'balus-common';
import { RTDBPath } from 'balus-common';
import type { ElementDescriptionTarget } from './ElementDescriptionTarget';

export class ElementDescriptionSetRepository extends MapRepository<
  ElementDescriptionJSON,
  ElementDescription,
  ElementDescriptionSetJSON,
  ElementDescriptionSet
> {
  static buildFromIds(
    viewModelId: ViewModelId,
    modelId: ModelId,
    target: ElementDescriptionTarget
  ): ElementDescriptionSetRepository {
    return new this(ElementDescription, ElementDescriptionSet, this.getDBPath(viewModelId, modelId, target));
  }

  private static getDBPath(viewModelId: ViewModelId, modelId: ModelId, target: ElementDescriptionTarget): DBPath {
    switch (target) {
      case 'Node':
        return RTDBPath.Node.descriptionsPath(viewModelId, modelId);
      case 'Zone':
        return RTDBPath.Zone.descriptionsPath(viewModelId, modelId);
      default:
        throw new Error(`Invalid target: ${target}`);
    }
  }
}
